<script setup lang="ts">
import PageCaption from '@sub/components/PageCaption.vue'
import { hasCompanyAccessToPlatform } from '@utils/tariff'

const i18nHead = useLocaleHead({})

useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang,
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])],
})

const store = useCompanyStore()

const route = useRoute()
const expired = computed(
  () =>
    store.isCompanyLoaded
    && typeof route.name === 'string'
    && (route.name.startsWith('booking-id') || route.name.startsWith('orders-id'))
    && !hasCompanyAccessToPlatform(store.company),
)
</script>

<template lang="pug">
.layout-container.flex#drawer
  .layout.flex-center-center.col-16.w-100p
    .template.br-24.max-w-800.w-100p.h-100p.flex.col-0.overflow-hidden
      template(v-if="expired")
        .expired.h-100p.max-w-420.m-auto.position-relative.flex-center-center.text-center.col-16
          .flex {{ $t('block.booking.disabled') }}
          .flex {{ $t('block.booking.write_admin') }}
          UiButton(label="block.booking.contact" :size="Sizes.Leia" :to="`mailto:${store.company.meta?.email}`")
      template(v-else)
        slot
    PageCaption

TransitionGroup.drawers.position-fixed.t-0.l-0.flex.h-100p.w-100p.z-index-200#drawer-inner(tag="div" name="drawer")

</template>

<style scoped>
.layout-container {
  min-height: max(600px, 100vh);
  @supports (min-height: 100dvh) {
    min-height: max(600px, 100dvh);
  }

  @screen md {
    /* max-height: max(800px, 100dvh); */
  }
}

.layout {
  --uno: p-b-16;
  @screen md {
    --uno: p-20;
  }
}

.template {
  /* overflow: hidden; */
  background: var(--cue-bg-neutral-primary);
  border: 1px solid var(--cue-border-neutral-none);

  @screen md {
    box-shadow: 6px 5px 36px 0 color-mix(in srgb, var(--cue-static-neutral-inverse-highest) 5%, transparent);
  }
}

.drawers {
  flex-direction: row-reverse;
  pointer-events: none;
}
</style>

<style>
body {
  @screen md {
    background: var(--cue-bg-surface-main);
  }
}
</style>
